var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
__name(_toConsumableArray, "_toConsumableArray");
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
__name(_nonIterableSpread, "_nonIterableSpread");
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
__name(_unsupportedIterableToArray, "_unsupportedIterableToArray");
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
__name(_iterableToArray, "_iterableToArray");
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
__name(_arrayWithoutHoles, "_arrayWithoutHoles");
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
__name(_arrayLikeToArray, "_arrayLikeToArray");
import React, { Component, Children } from "react";
import classnames from "classnames";
import { OverlayHeader } from "./Header";
import { overlayCls, overlaySidebarCls, overlaySidebarLeftCls, overlaySidebarRightCls, overlayCenteredCls, overlaySmallCls, overlayMediumCls, overlaySemitransparentCls, overlayVisibleCls, overlayClosingCls, overlayBodyHiddenOverflowCls, sidebarAnimationDuration } from "./Overlay.less";
import { OverlayContainer } from "./Container";
var SIZE_TO_CLASSNAME = {
  small: overlaySmallCls,
  medium: overlayMediumCls
};
var SIDEBAR_ANIMATION_DURATION = sidebarAnimationDuration * 1e3;
var ESCAPE_KEY = "Escape";
var CLASSNAME_SEPARATOR = " ";
var SIDEBAR_ALIGN_CLASSNAMES = {
  left: overlaySidebarLeftCls,
  right: overlaySidebarRightCls
};
var addDocumentBodyClassName = /* @__PURE__ */ __name(function addDocumentBodyClassName2() {
  var className = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var isVisible = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (typeof document === "undefined") {
    return;
  }
  var bodyClassNames = document && document.body && document.body.className || "";
  var hasOverflowClassName = bodyClassNames.indexOf(className) !== -1;
  if (hasOverflowClassName && !isVisible) {
    document.body.className = bodyClassNames.replace(className, "");
  } else if (!hasOverflowClassName && isVisible) {
    document.body.className = [].concat(_toConsumableArray(bodyClassNames.split(CLASSNAME_SEPARATOR)), [className]).join(CLASSNAME_SEPARATOR);
  }
}, "addDocumentBodyClassName");
var Overlay = /* @__PURE__ */ function(_Component) {
  function Overlay2(props) {
    var _this;
    _classCallCheck(this, Overlay2);
    _this = _callSuper(this, Overlay2, [props]);
    _defineProperty(_this, "renderChildren", function() {
      var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return Children.map(children, function(child) {
        if (!child) {
          return null;
        }
        if (child.type === OverlayContainer) {
          return /* @__PURE__ */ React.cloneElement(child, child.props, _this.renderChildren(child.props.children));
        }
        return child.type === OverlayHeader ? /* @__PURE__ */ React.cloneElement(child, _objectSpread(_objectSpread({}, child.props), !child.props.closeComponent ? {
          onClose: _this.handleClose
        } : null)) : child;
      });
    });
    _this.bindMethods();
    _this.state = {
      isVisible: _this.props.isVisible,
      isClosing: false
    };
    addDocumentBodyClassName(overlayBodyHiddenOverflowCls, _this.props.isVisible);
    return _this;
  }
  __name(Overlay2, "Overlay");
  _inherits(Overlay2, _Component);
  return _createClass(Overlay2, [{
    key: "componentDidMount",
    value: /* @__PURE__ */ __name(function componentDidMount() {
      this.updateEventListeners();
    }, "componentDidMount")
    /**
     * componentDidUpdate
     */
  }, {
    key: "componentDidUpdate",
    value: /* @__PURE__ */ __name(function componentDidUpdate(prevProps, prevState) {
      this.updateEventListeners();
      if (this.props.isVisible !== prevProps.isVisible) {
        this.setState({
          isVisible: this.props.isVisible
        });
      }
      if (this.state.isVisible !== prevState.isVisible) {
        addDocumentBodyClassName(overlayBodyHiddenOverflowCls, this.state.isVisible);
      }
    }, "componentDidUpdate")
    /**
     * componentWillUnmount
     */
  }, {
    key: "componentWillUnmount",
    value: /* @__PURE__ */ __name(function componentWillUnmount() {
      addDocumentBodyClassName(overlayBodyHiddenOverflowCls, false);
      clearTimeout(this.closeTimeout);
      document.removeEventListener("keyup", this.handleKeyUp);
    }, "componentWillUnmount")
    /**
     * updateEventListeners
     */
  }, {
    key: "updateEventListeners",
    value: /* @__PURE__ */ __name(function updateEventListeners() {
      this.props.isVisible ? document.addEventListener("keyup", this.handleKeyUp, {
        capture: true
      }) : document.removeEventListener("keyup", this.handleKeyUp);
    }, "updateEventListeners")
    /**
     * handleKeyUp
     * @param {Event} event
     * @returns {void}
     */
  }, {
    key: "handleKeyUp",
    value: /* @__PURE__ */ __name(function handleKeyUp(event) {
      if (event.key !== ESCAPE_KEY) {
        return;
      }
      this.handleClose(event);
    }, "handleKeyUp")
    /**
     * handleClose
     * @param {Event} event
     */
  }, {
    key: "handleClose",
    value: /* @__PURE__ */ __name(function handleClose(event) {
      var _this2 = this;
      event.preventDefault();
      if (this.props.sidebar) {
        this.setState({
          isClosing: true
        });
        clearTimeout(this.closeTimeout);
        this.closeTimeout = setTimeout(function() {
          _this2.closeOverlay(event);
        }, SIDEBAR_ANIMATION_DURATION);
      } else {
        this.closeOverlay(event);
      }
    }, "handleClose")
    /**
     * handleClickOutside
     *
     * @param {Event} event
     */
  }, {
    key: "handleClickOutside",
    value: /* @__PURE__ */ __name(function handleClickOutside(event) {
      if (event && event.target && // $FlowFixMe
      typeof event.target.className === "string" && (event.target.className.indexOf(overlaySemitransparentCls) > -1 || this.isCentered() && event.target.className.indexOf(overlayCenteredCls) > -1)) {
        this.handleClose(event);
      }
    }, "handleClickOutside")
    /**
     * closeOverlay
     *
     * @param {Event} event
     */
  }, {
    key: "closeOverlay",
    value: /* @__PURE__ */ __name(function closeOverlay(event) {
      var onClose2 = this.props.onClose;
      this.setState({
        isVisible: false,
        isClosing: false
      });
      if (onClose2 && typeof onClose2 === "function") {
        onClose2(event);
      }
    }, "closeOverlay")
    /**
     * bindMethods
     */
  }, {
    key: "bindMethods",
    value: /* @__PURE__ */ __name(function bindMethods() {
      this.handleKeyUp = this.handleKeyUp.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.closeOverlay = this.closeOverlay.bind(this);
      this.updateEventListeners = this.updateEventListeners.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }, "bindMethods")
  }, {
    key: "isCentered",
    value: /* @__PURE__ */ __name(function isCentered() {
      var _this$props = this.props, centered = _this$props.centered, size = _this$props.size;
      return !!([true, false].indexOf(centered) > -1 ? centered : ["small", "medium"].indexOf(size) > -1);
    }, "isCentered")
    /**
     * render
     */
  }, {
    key: "render",
    value: /* @__PURE__ */ __name(function render() {
      var _this$props2 = this.props, type = _this$props2.type, sidebar = _this$props2.sidebar, sidebarAlign = _this$props2.sidebarAlign, size = _this$props2.size, className = _this$props2.className, children = _this$props2.children, topOffset = _this$props2.topOffset, closeOnOutsideClick = _this$props2.closeOnOutsideClick;
      var _this$state = this.state, isVisible = _this$state.isVisible, isClosing = _this$state.isClosing;
      var renderedChildren = this.renderChildren(children);
      var offsetStyles = {};
      if (topOffset) {
        var topOffsetPx = topOffset ? "".concat(parseInt(topOffset, 10), "px") : null;
        offsetStyles = {
          style: {
            height: "calc(100% - ".concat(topOffsetPx, ")"),
            marginTop: topOffsetPx
          }
        };
      }
      return /* @__PURE__ */ React.createElement("section", _extends({}, type === "semitransparent" && closeOnOutsideClick ? {
        onClick: this.handleClickOutside
      } : null, {
        className: classnames(overlayCls, className, size && SIZE_TO_CLASSNAME[size], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, overlaySidebarCls, sidebar), overlaySemitransparentCls, type === "semitransparent"), overlayVisibleCls, isVisible), overlayClosingCls, isClosing), sidebar && sidebarAlign && SIDEBAR_ALIGN_CLASSNAMES[sidebarAlign])
      }, offsetStyles), this.isCentered() ? /* @__PURE__ */ React.createElement("div", {
        className: overlayCenteredCls
      }, renderedChildren) : renderedChildren);
    }, "render")
  }]);
}(Component);
_defineProperty(Overlay, "defaultProps", {
  className: null,
  children: null,
  centered: null,
  size: null,
  topOffset: null,
  onClose: /* @__PURE__ */ __name(function onClose() {
  }, "onClose"),
  sidebar: false,
  sidebarAlign: "left",
  closeOnOutsideClick: false
});
export {
  Overlay
};
